import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-64827704"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "career-hrs" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "top-line" }, [
  /*#__PURE__*/_createElementVNode("h1", { class: "title" }, " We're Excited To Meet You! "),
  /*#__PURE__*/_createElementVNode("p", { class: "title-text" }, " Get ready for the biggest journey of your career! ")
], -1))
const _hoisted_4 = { class: "hr-list" }
const _hoisted_5 = { class: "img" }
const _hoisted_6 = ["src", "alt"]
const _hoisted_7 = ["href"]
const _hoisted_8 = ["src"]
const _hoisted_9 = { class: "hr-info" }
const _hoisted_10 = { class: "name" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.hrList, (hr) => {
          return (_openBlock(), _createElementBlock("div", {
            key: hr.name,
            class: "hr"
          }, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("img", {
                class: "hr-photo",
                src: require(`@/assets/img/people/${hr.image}.webp`),
                alt: hr.name
              }, null, 8, _hoisted_6),
              _createElementVNode("a", {
                class: "hover-overlay",
                href: hr.linkedin,
                target: "_blank"
              }, [
                _createElementVNode("img", {
                  src: require('@/assets/img/social/linkedin_blue.svg'),
                  alt: "Linkedin"
                }, null, 8, _hoisted_8)
              ], 8, _hoisted_7)
            ]),
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("h5", _hoisted_10, _toDisplayString(hr.name), 1),
              _createElementVNode("p", null, _toDisplayString(hr.email), 1),
              _createElementVNode("p", null, _toDisplayString(hr.position), 1)
            ])
          ]))
        }), 128))
      ])
    ])
  ]))
}